import { render, staticRenderFns } from "./lecturerDetail.vue?vue&type=template&id=6493cd72&scoped=true&"
import script from "./lecturerDetail.vue?vue&type=script&lang=js&"
export * from "./lecturerDetail.vue?vue&type=script&lang=js&"
import style0 from "./lecturerDetail.vue?vue&type=style&index=0&id=6493cd72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493cd72",
  null
  
)

export default component.exports